<template>
  <el-dropdown
    ref="dropdownRef"
    trigger="click"
    style="margin-top: -3px !important; width: 60px; cursor: pointer"
  >
    <div class="dropdown-trigger" style="margin-right: 20px; position: relative">
      <img
        style="height: 35px; width: 35px"
        data-v-2b3b0c9a=""
        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABQCAMAAAC5zwKfAAAAAXNSR0IArs4c6QAAAVNQTFRFAAAA////////////////////////9vb29/f39/f3+Pj49/f3+Pj49fX19vb29fX19vb29vb29vb29vb29vb29vb29vb29vb29fX19vb29fX19fX19vb29fX19fX19fX19vb29vb29vb29vb29fX19fX19fX19vb29vb2AAAAAQEBAgICAwMDBAQEBQUFCwsLDg4ODw8PEBAQEhISExMTFxcXGBgYIiIiJSUlKCgoKysrLS0tMTExODg4OTk5PDw8QkJCSUlJSkpKS0tLTk5OUVFRV1dXWFhYX19fYWFhYmJiZGRkaGhobW1tc3Nzfn5+f39/gICAhoaGiIiIioqKj4+PmZmZp6enqampq6urrq6uubm5v7+/wcHBxsbGx8fHyMjIycnJy8vLzc3N0tLS1NTU29vb3t7e4ODg5OTk7e3t7+/v8PDw8fHx8vLy9PT09fX1MYtzuwAAACl0Uk5TAAEGBwkSFBweHyc/RU1SaGxtcXKPkpOUnbG6u8XR0tXd3+Ll7O/x+f4CaWuJAAAClUlEQVRYw8WZ6VvTQBDGl5IWIQ3pfR8Eei0g4oXifZ+oKOIt3goeMP//J0tLK7Q7szmmj+/XzP6ebDKZmX0jBK1INJYpVJxas1lzKoVMLBoR/mVYqXILBtQqpyzDD23MzDUAUSNnjnnEjdszQGrGHvey18QcaDWXcL1zywFXcixXuMk8uFb+mJ43XQcPqk9rcKE0eFQ6RPHCJfCsUhjnTVTBh6oTGG9qFnxpdgq5P5+8NlF5j+Eq+FZV8RxDJQig0vC7TkMgpYfyGQJqIMMn60GB9aNfYR4CK3+kvgCDDtUew+EAOv/qYxJYlOjXe019/rZx/dzy0sqltZe/6Rre6wo2Gfbx5rzsaeXpLyrUPuhvVD/ae3JcHtbqB6pzdXuhSfEeyAGdfEeEmx1gjohYl0M68wMPz3VypoEHfFkaBsrbeHzD0CT1QwVPLnynkztFAE+pgHITX5BqA8v45W0lTz7CV5Tb81qLSEE18C6+ohURUWLHW2rgHWJJVMR5gTGR5QVmRZEXWBQVXmBFOLxAR9R4gTXR5AU2+YHsW6Zeyms18Cr5Uoi02b2gBso3VNoQib2J8OR5vPsViE9v5zQGlBvoooyIodfWUJ5c3saLA1q+Pi/iQHkfL19ogb1G8OT8FlpgsRbwSpK6gbYArEk9poELu2iTsnzd4UW8jWKNfv0sjlu88hVv9OgosreD6ic1ipDDUlefnnX0Qhto6se5LrC70Vu6uINxTjNw7ute58G914XZLkdigD/PV09cfqu1NfpGSYJ5aOc/VrAffPiPZvyHR/bjLf8BnN8iYDcx+G0WfiOI36riN9P47T5+Q3IElim/qbtfH5NubOek8f+M8RFY9yP4udD//RHPFnu/P4rZuPb3x1/0Rpu322bkPAAAAABJRU5ErkJggg=="
        class="icon"
      />
      <el-badge :value="allDataTotal" v-show="allDataTotal !== 0" class="items_message"></el-badge>
      <span
        data-v-2b3b0c9a=""
        class="ant-badge"
        style="zoom: 0.8; position: absolute; top: 25px"
      ><a data-v-2b3b0c9a="" href="#"></a><!----></span>
    </div>

    <template #dropdown>
      <div class="boxs">
        <div class="tops_side">
          <div class="top_message">{{ $t('sys.notice.unreadas') }}</div>
          <el-button
            type="primary"
            :icon="Select"
            link
            style="font-family: PingFangSC, PingFang SC; font-weight: 500; font-size: 18px"
            @click="$emit('mark-all-read')"
            :loading="isReadAllLoading"
          >
            {{ $t('common.cds41') }}
          </el-button>
        </div>
        <div class="inner_boxs">
          <div v-if="resultTargetDataList.length === 0" class="empty" style="padding-bottom: 60px">
            {{ $t('common.notice.nomore') }}
          </div>
          <template v-else>
            <Message
              :resultTargetDataList="resultTargetDataList"
              @changePages="$emit('change-page')"
              @getUnReads="$emit('refresh-unreads')"
              @closeDropdownRef="$emit('close')"
            >
              <template #loadings>
                <div
                  style="display: flex; justify-content: center; width: 100%"
                  :loading="allNewDataIsLoading"
                ></div>
              </template>
            </Message>
          </template>
          <div class="item_box">
            <el-button link type="primary" style="padding: 12px 0px; font-size: 14px" @click="$emit('close'); $emit('view-all')">
              {{ $t('common.notice.viewall') }}
            </el-button>
          </div>
        </div>
      </div>
    </template>
  </el-dropdown>
</template>

<script>
import { ref } from 'vue'
import { Select } from '@element-plus/icons-vue'
import Message from '@/components/Message'

export default {
  name: 'HeaderNoticeDropdown',
  components: { Message },
  props: {
    allDataTotal: {
      type: Number,
      default: 0,
    },
    isReadAllLoading: {
      type: Boolean,
      default: false,
    },
    resultTargetDataList: {
      type: Array,
      default: () => [],
    },
    allNewDataIsLoading: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['mark-all-read', 'change-page', 'refresh-unreads', 'close', 'view-all'],
  setup() {
    const dropdownRef = ref(null)

    const handleClose = () => {
      dropdownRef.value?.handleClose?.()
    }

    return {
      dropdownRef,
      handleClose,
      Select,
    }
  },
}
</script>

<style scoped>
.dropdown-trigger {
  display: flex;
  justify-content: center;
  align-items: center;
}

.boxs {
  width: 350px;
  min-width: 350px;
  height: auto;
  max-height: 540px !important;
}

.boxs .empty {
  padding-top: 50px;
  display: flex;
  justify-content: center;
  margin-top: 20px;
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
}

.boxs .item_box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: absolute;
  align-items: center;
  z-index: 9;
  bottom: 0px;
  width: 100%;
  background: white;
}

.boxs .tops_side {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px 15px;
  position: absolute;
  top: 0px;
  width: 100%;
  background: white;
}

.boxs .tops_side .top_message {
  font-size: 18px;
  line-height: 18px;
  font-weight: 600;
  color: #333;
}

.inner_boxs {
  min-height: 106px;
  margin-top: 50px;
  margin-bottom: 30px;
}

.items_message {
  position: absolute;
  top: 36px;
  left: 48px;
}

.items_message :deep(.el-badge__content) {
  position: absolute;
  right: calc(-8px + var(--el-badge-size) / 2) !important;
  top: -40px !important;
}
</style>
